(function($) {
  let _ = require("lodash");

  let Products = function(element, options) {
    let elem = $(element);
    let obj = this;
    let settings = $.extend(
      {
        id: null,
        token: null,
        countryId: null, // default country id
        model: null,
        variants: [],
        currency: 'RM',
        urls: {}
      },
      options || {}
    );

    let variant = null;

    /*
     * Public method
     * Can be called outside class
     */
    this.index = function() {
    };

    this.show = function() {
      $("a.fancybox").fancybox({
        "titlePosition": "over"
      });

      $("div.picture-thumb a.picture").on("click", function() {
        $("a#picture-placeholder").prop("href", $(this).prop("href")).children("img").prop("src", $(this).prop("href"));
        return false;
      });

      // ajax add cart
      $(function() {
        let options = {
          dataType: "json",
          //target:        '#ajax-form-container',
          beforeSubmit: function() {
            $("#btn-add-cart").button("loading");
          },
          complete: function() {
            //console.info('complete');
          },
          success: function(result, status) {
            if (result.success) {
              $.scrollTo(0, 500, {
                onAfter: function() {
                  $("#cart-size").addClass("active").hide().fadeIn(500, function() {
                    $(this).html(result.cart_size);
                    $(this).delay(500).fadeOut(400, function() {
                      $(this).removeClass("active").show();
                    });
                  });
                }
              });
              $("#btn-add-cart").removeClass("btn-primary").addClass("btn-primary").button("complete");
            }

            setTimeout(function() {
              $("#btn-add-cart").removeClass("btn-primary").addClass("btn-primary").button("reset");
            }, 500);
          }
          //timeout:   3000
        };

        $("form#form-add-cart").ajaxForm(options);
      });

      $('select[id^="product-option-"]').on('change', function () {
        update();
      });

      $("a.fancybox-video").fancybox({
        maxWidth: 640,
        maxHeight: 480,
        fitToView: true,
        autoSize: true,
        closeClick: false,
        openEffect: "none",
        closeEffect: "none"
      });

      $(".read-more").readMore({
        expandTrigger: ".prompt",
        previewHeight: 300,
        fadeColor1: "rgba(255,255,255,0)",
        fadeColor2: "rgba(255,255,255,1) 80%"
      });

      $("#container").on("click", "#product-reviews .pagination-container a", function(e) {
        $.ajax({
          type: "get",
          url: $(this).attr("href"),
          dataType: "json",
          beforeSend: function() {
            msg = Messenger().post({
              message: "Loading ...",
              type: "info",
              hideAfter: 20,
              showCloseButton: true,
              hideOnNavigate: true
            });
          },
          complete: function() {
          },
          success: function(result) {
            if (result.success != null && !result.success) {
              msg.update({ message: result.message, type: "error" });
            } else {
              msg.hide();

              $("#product-reviews .user-reviews").append(result.html);

              $("#product-reviews > .pagination-container").html(result.pagination_html);
            }
          }
        });

        return false;
      });

      update();
    };

    /**
     * Bind every page load including PJAX request
     */
    bindIndex = () => {
      $("#filter-options").on("show.bs.collapse", function() {
        $(".product-backdrop").fadeIn("normal", function() {
        });
      });

      $("#filter-options").on("hide.bs.collapse", function() {
        $(".product-backdrop").hide();
      });

      $(".filtered-tags .tag").length > 0
        ? $(".products-filter .clear-filter").show()
        : $(".products-filter .clear-filter").hide();
    };

    function updatePicture() {
      if (variant && variant.url_pictures)
        $("a#picture-placeholder").prop("href", variant.url_pictures.actual).children("img").prop("src", variant.url_pictures.big);
    }

    function updateUnavailable() {
      $("#price-preview").text("Unavailable");
      $("#btn-add-cart").text("Unavailable").addClass("disabled").attr("disabled", "disabled");

      $("#variant_id").val(null).attr("disabled", "disabled");
    }

    function updateSoldOut() {
      $("#price-preview").text("Sold out");
      $("#btn-add-cart").text("Sold out").addClass("disabled").attr("disabled", "disabled");

      $("#variant_id").val(null).attr("disabled", "disabled");
    }

    function updateOK(variant) {
      //if(typeof variant.inventory != 'undefined')
      //    variant.inventory.quantity -= 1;

      $("#variant_id").val(variant.id);

      $("#price-preview").text(sprintf("%s %s", settings.currency, variant.price));

      if (variant.price != variant.price_before) {
        $("#price-preview").append($("<del class=\"ml-3\"/>").html(sprintf("%s %s", settings.currency, variant.price_before)));
      } else if (variant.normal_price != null) {
        $("#price-preview").append($("<del class=\"ml-3\"/>").html(sprintf("%s %s", settings.currency, variant.normal_price)));
      }

      if ($("#btn-add-cart").hasClass("disabled")) $("#btn-add-cart").removeClass("disabled").attr("disabled", false).text("Add to cart");

      $("#variant_id:disabled").attr("disabled", false);

    }

    function update() {
      let selected = {};

      variant = null;

      $("select[id^=\"product-option-\"]").each(function() {
        selected[$(this).attr("data-id")] = ($(this).val());
      });

      let keyLength = $.map(selected, function(value, key) {
        return key;
      }).length;


      $.each(settings.variants, function(k, v) {
        let match = 0;

        $.each(selected, function(field, value) {
          if (v["type" + field + "_value"] == value)
            match++;
        });

        if (match == keyLength) {
          //console.info("variant found at " + k);

          return variant = v;
        }
      });

      if (!variant) {
        updateUnavailable();
      } else if (typeof variant.inventory != "undefined" && !variant.inventory.allow_empty_purchase && variant.inventory.quantity <= 0) {
        updateSoldOut();
      } else {
        updateOK(variant);
      }

      updatePicture();

      //console.info(variant);
    }

    bindPjax = () => {
    };

    enableZoom = () => {
      $(".zoom").zoom({
        onZoomIn: function() {
          $(this)
            .closest(".zoom")
            .find("img:not(.zoomImg)")
            .css("opacity", 0);
        },
        onZoomOut: function() {
          $(this)
            .closest(".zoom")
            .find("img:not(.zoomImg)")
            .css("opacity", 1);
        }
      });
    };
  };

  $.pjax.defaults.maxCacheLength = 0;

  $.products = function(options) {
    return new Products(null, options);
  };
})(jQuery);
